import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ApiError, api } from '../../lib/api'
import { useAuth } from '../../context/AuthContext'
import type { Me } from '../../lib/types'

function homeForRole(me: Me) {
  if (me.role === 'super_admin' || me.role === 'atuune_admin') return '/admin'
  if (me.role === 'provider') return me.provider_onboarding_complete ? '/practice/provider' : '/practice/provider/onboarding'
  if (me.role === 'practice_owner' || me.role === 'practice_admin') return '/practice'
  if (me.role === 'patient') return '/patient'
  return '/'
}

export default function ResetPasswordConfirm() {
  const { token } = useParams<{ token: string }>()
  const navigate = useNavigate()
  const { loginWithToken } = useAuth()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    if (password.length < 8) {
      setError('Password must be at least 8 characters.')
      return
    }
    if (password !== confirm) {
      setError('Passwords do not match.')
      return
    }
    setBusy(true)
    try {
      const result = await api(`/patient-auth/password-reset/${token}/confirm`, {
        method: 'POST',
        body: JSON.stringify({ password }),
      })
      const me = await loginWithToken(result.access_token)
      navigate(homeForRole(me), { replace: true })
    } catch (err) {
      if (err instanceof ApiError) {
        setError(err.message || 'This reset link is invalid or has expired.')
      } else {
        setError('Something went wrong. Try again.')
      }
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="auth-shell warm-theme">
      <div className="auth-card">
        <h1>Choose a new password</h1>
        <form onSubmit={submit}>
          <div className="field">
            <label>New password</label>
            <input className="inp" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} autoFocus />
          </div>
          <div className="field">
            <label>Confirm password</label>
            <input className="inp" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} />
          </div>
          {error && <div className="form-error" role="alert">{error}</div>}
          <button className="btn full" type="submit" disabled={busy}>{busy ? 'Saving…' : 'Set password & sign in'}</button>
        </form>
      </div>
    </div>
  )
}
